<template>
  <div class="relative" ref="ItineraryDropdownModal">
    <button
      class="inline-flex items-center text-gray-500 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded-lg text-sm h-full px-4 py-2"
      type="button"
      @click="showDropdown = true"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="w-5 h-5 me-2"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path
          d="M4 4h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v7l-6 2v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227z"
        />
      </svg>
      {{ t("itinerary.filter.button", "Filtros") }}
      <svg
        class="w-2.5 h-2.5 ms-2.5"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 10 6"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="m1 1 4 4 4-4"
        />
      </svg>
    </button>
    <!-- Dropdown menu -->
    <div
      class="absolute z-10 bg-white border divide-y divide-gray-100 rounded-md shadow w-60 top-10 left-1 border-eblack-200"
      :hidden="!showDropdown"
    >
      <div class="flex flex-col w-full gap-4 p-2">
        <fieldset class="p-2 border rounded-lg">
          <legend class="text-sm">
            {{ t("itinerary.filter.state", "Estado") }}
          </legend>
          <div>
            <select
              data-testid="itinerary-state-filter"
              class="w-full text-sm border border-gray-200 rounded-lg"
              v-model="filter.state"
              @change="handleFilter()"
            >
              <option value="">
                {{ t("itinerary.filter.all", "Todos") }}
              </option>
              <option
                v-for="stateOption in stateOptions"
                :key="stateOption.value"
                :value="stateOption.value"
              >
                {{ stateOptionLabel(stateOption) }}
              </option>
            </select>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
import { ITINERARY_FILTER_OPTIONS } from "@/domains/itinerary/models";
import { useItineraryI18n } from "@/domains/itinerary/composables";

export default {
  name: "ItineraryFilter",
  props: ["applyFilter", "selectedState"],
  watch: {
    selectedState: {
      immediate: true,
      handler(val) {
        this.filter.state = val || "";
      },
    },
  },
  setup() {
    const { t } = useItineraryI18n();
    return { t };
  },
  data() {
    return {
      showDropdown: false,
      stateOptions: ITINERARY_FILTER_OPTIONS,
      filter: {
        state: "",
      },
    };
  },
  methods: {
    handleClickOutside(event) {
      if (
        this.$refs.ItineraryDropdownModal &&
        !this.$refs.ItineraryDropdownModal.contains(event.target)
      ) {
        this.showDropdown = false;
      }
    },
    handleFilter() {
      this.applyFilter(this.filter);
    },
    stateOptionLabel(stateOption) {
      return this.t(stateOption.labelKey, stateOption.label);
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style lang="scss" scoped></style>
